import { render, staticRenderFns } from "./attachment-preview.vue?vue&type=template&id=2519c4f2"
import script from "./attachment-preview.js?vue&type=script&lang=js&external"
export * from "./attachment-preview.js?vue&type=script&lang=js&external"
import style0 from "./attachment-preview.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports